import {
  createContext,
  useContext,
  useEffect,
  useCallback,
  useState,
  useRef,
} from "react";
import { notification } from "antd";
import {
  useGetNewNotificationsQuery,
  useGetMyNotificationsQuery,
  useAddANotificationMutation,
  useDismissNotificationMutation,
} from "../redux/api/notifications";
import { useSelector } from "react-redux";

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [notificationHistory, setNotificationHistory] = useState([]);
  const [addNotificationMutate] = useAddANotificationMutation();
  const [notificationPop, setNotificationPop] = useState(false);
  // const [isClosedByButton, setIsClosedByButton] = useState(false);
  const notificationButtonRef = useRef(null);

  const toggleNotificationPop = useCallback(() => {
    // setIsClosedByButton(true); // Flag that we're using the button
    setNotificationPop((prev) => !prev);
  }, []);

  const selectedClient = useSelector(
    (state) => state.genericReporting.selectedDropdownValues['client_name']
  );

  const { data: notificationsApi } = useGetNewNotificationsQuery({
    clientName: selectedClient,
  });

  const { data: notificationHistoryApiData } = useGetMyNotificationsQuery({
    clientName: selectedClient,
  });

  useEffect(() => {
    if (notificationsApi) {
      setNotifications(notificationsApi);
    }
  }, [notificationsApi]);

  useEffect(() => {
    console.log("notificationHistoryApi", notificationHistoryApiData);
    if (notificationHistoryApiData) {
      setNotificationHistory(notificationHistoryApiData);
    }
  }, [notificationHistoryApiData]);

  const [dismissNotification] = useDismissNotificationMutation();

  const removeNotificationFromHistory = useCallback(
    async (notificationObj) => {
      if (!notificationObj) return;
      try {
        await dismissNotification({
          clientName: selectedClient,
          notificationTitle: notificationObj.title,
          notificationMessage: notificationObj.message,
          notificationDeliverUntil: notificationObj.deliver_until,
          notificationType: notificationObj.type,
        });
      } catch (err) {
        console.error("Failed to dismiss notification:", err);
      }
    },
    [dismissNotification, selectedClient]
  );

  const clearHistory = useCallback(() => {
    // remove all notifications from my notifications
    notificationHistory.forEach((notif) => {
      removeNotificationFromHistory(notif);
    });
  }, [removeNotificationFromHistory, notificationHistory]);

  const addNotification = useCallback(
    async (notificationObj) => {
      try {
        await addNotificationMutate({
          clientName: selectedClient,
          notificationTitle: notificationObj.title,
          notificationMessage: notificationObj.message,
          notificationDeliverUntil: notificationObj.deliver_until,
          notificationType: notificationObj.type,
        });
      } catch (err) {
        console.error("Failed to add notification:", err);
      }
    },
    [addNotificationMutate, selectedClient]
  );

  useEffect(() => {
    notifications.forEach((notif) => {
      notification[notif.type || "info"]({
        message: notif.title,
        description: notif.message,
        key: notif.id,
        placement: "bottomRight",
      });
    });
  }, [notifications]);

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        notificationHistory,
        clearHistory,
        removeNotificationFromHistory,
        addNotification,
        notificationPop,
        setNotificationPop,
        toggleNotificationPop,
        notificationButtonRef,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotification must be used within a NotificationProvider"
    );
  }
  return context;
}
